import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.jaxCancerKnowledgeBase',
  title: {
    id: 'omicsExplorer.filters.jaxCancerKnowledgeBase',
    defaultMessage: 'JAX Cancer Knowledgebase',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'jaxKnowledge',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.gene',
        searchValue: 'gene',
        intlLabel: {
          id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.gene.checkbox',
          defaultMessage: 'Curated Genes',
        },
      },
    ],
  },
};

export const shortConfig: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.jaxCancerKnowledgeBase',
  title: {
    id: 'omicsExplorer.filters.jaxCancerKnowledgeBase',
    defaultMessage: 'JAX Cancer Knowledgebase',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'jaxKnowledge',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.gene',
        searchValue: 'gene',
        intlLabel: {
          id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.gene.checkbox',
          defaultMessage: 'Curated Genes',
        },
      },
      {
        id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.proteinEffect',
        searchValue: 'variant,impact',
        intlLabel: {
          id: 'omicsExplorer.filters.jaxCancerKnowledgeBase.jaxKnowledge.proteinEffect.checkbox',
          defaultMessage: 'Protein Effect',
        },
      },
    ],
  },
};
